<template>
  <div class="animated fadeIn" v-if="!loading">
    <basic-heading title="Receiving Labels" class="print-hidden mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" @buttonAction="handleAction" />
      </template>
    </basic-heading>
    <sample-receiving-labels :samples="samples" />
  </div>
</template>

<script>
import SampleCollection from "@/collections/lab/SampleCollection";
import SampleReceivingLabels from "@/components/lab/sample/SampleReceivingLabels";
import BasicHeading from "@/components/shared/BasicHeading";
import { getModel } from "@/shared/fetch-utils";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import DymoService from '@/dymo/DymoService';

export default {
  name: 'SampleReceiveLabelIndex',
  components: {
    BasicHeading,
    SampleReceivingLabels,
    HeaderButtonGroup
  },
  data() {
    return {
      sample_id: this.$route.params.sample_id || null,
      samples: new SampleCollection(),
      loading: true,
    }
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: 'fa-tag mr-2',
            variant: 'success',
            text: 'Print Label',
            with_action: true,
            action_data: 'print_label',
          },
        ],
      };
    },
  },
  created () {
    this.loading = true

    this.init()
  },
  methods: {
    async init() {
      if (this.sample_id) {
        const sample = await getModel({
          model_type: "sample",
          id: this.sample_id,
          message: this.$bvToast
        });

        this.samples.add(sample)
      }

      // initialize DYMO
      await DymoService.initFramework()

      this.loading = false;
    },

    handleAction (action) {
      if (action == 'print_label') {
        this.printLabel()
      }
    },

    async printLabel() {
      try {
        const labelXml = DymoService.createLabel('http://localhost:8084/js/labels/template.label')

        const printResult = await DymoService.printLabel(labelXml)
        console.log('Label printed successfully:', printResult)
      } catch (error) {
        console.error('Failed to print label:', error)
      }
    }
  }
};
</script>
